import React, { useState, useEffect } from "react";
import { Row, Col, Button } from 'reactstrap';
import { useTemplateSurvey } from '../../hooks/templateSurvey/useTemplateSurvey'
import './styleTemplateSurvey.css';
import Select, { components } from "react-select";
import QuestionCard from "./QuestionCard";
import { ToastAletGlobal } from '../alertDialog/ToastAletGlobal';
import { CustomAlertDialogGlobal } from '../alertDialog/CustomAlertDialogGlobal';
import { CustomAlertModal } from '../customMoldalAlert/CustomAlertModal';
import { Dialog } from 'primereact/dialog';








export const IndexTemplateSurvey = () => {


    const {
        // ? CONFIGURATION STATES
        formSurvey,
        questions,
        timeValue,

        // ?  CONFIGURATION HANDLES
        handleRestoreDemo,
        handleChangeSurvey,
        handleAddQuestion,
        handleUpdateQuestion,
        handleDeleteQuestion,


        // ? CONFIGURATION PREVIEW
        handleSelectClosedOption,
        selectedClosedOptions,
        openSubQuestionAnswers,
        timeSubQuestionAnswers,
        setOpenSubQuestionAnswers,
        setTimeSubQuestionAnswers,
        singleMultipleSubAnswers,
        handleTimeChange,
        fastingTime,
        timeNotApplicable,
        handleMultipleSubAnswer,
        multipleSubAnswers,
        setSingleMultipleSubAnswers,



        // ? CONFIGURATION METHODS
        departments,

        // ? ALERT
        showToast,
        toastType,
        toastTitle,
        toastMessage,
        closeToastAlert,

        // ? MULTIPLE
        multipleAnswers,
        handleMultipleAnswerChange,
        handleSingleAnswerChange,
        singleAnswers,

        // ? SAVE TEMPLATES
        handleSave,

        // ? alert
        customAlert,

        LisSurvey,
        showAlert,
        confirmRestore,
        cancelRestore,
        idTemplate,
        LisSurvey2,
        handleToggleSignature,


        // ? ORDER
        handleOpenOrderDialog,
        showOrderDialog,
        setShowOrderDialog,
        handleSaveQuestionOrder,
        orderQuestions,
        handleDragStartQuestion,
        handleDragEnterQuestion,
        handleDragEndQuestion,
        draggedQuestionIndex,
        dragOverQuestionIndex,
        getQuestionTypeLabel,
        dragWidth,
        dragPosition,
        handleDragQuestion,
        dragOffset



    } = useTemplateSurvey()






    const SurveySamplingOption = (
        props
    ) => {
        return (
            <components.Option {...props}>
                <div className="survey-sampling-select-option">

                    <div className="survey-sampling-select-option-icon">
                        <i className="fa fa-tint"></i>
                    </div>

                    <div className="survey-sampling-select-option-text">
                        <span className="survey-sampling-select-option-label">
                            {props?.data?.label}
                        </span>

                        <small>
                            Sección clínica
                        </small>
                    </div>

                </div>
            </components.Option>
        );
    };




    return (
        <div className="survey-sampling-container " >
            {
                // ! QUESTION
            }
            <div className="survey-sampling-header pt-0 pb-0">
                <Row className="survey-sampling-header-row">

                    {
                        // ! INFORMATION
                    }

                    <Col
                        xs="12"
                        lg={formSurvey.id_template > 0 ? 7 : 5}
                        className="survey-sampling-header-information"
                    >
                        <div className="survey-sampling-header-icon">
                            <i className="fa fa-wpforms"></i>
                        </div>

                        <div className="survey-sampling-header-content">

                            <h1 className="survey-sampling-header-title">
                                {
                                    (idTemplate === null || idTemplate === undefined)
                                        ?
                                        "Diseñador de Consentimientos Informados"
                                        :
                                        "Edición de Consentimiento Informado"
                                }
                            </h1>
                        </div>
                    </Col>

                    {
                        // ! BUTTONS
                    }

                    <Col
                        xs="12"
                        lg={formSurvey.id_template > 0 ? 5 : 7}
                        className="survey-sampling-header-actions"
                    >

                        <Button
                            type="button"
                            className="survey-sampling-button-restore"
                            onClick={(idTemplate === null || idTemplate === undefined) ? LisSurvey : LisSurvey2}
                            outline
                        >
                            <i className="fa fa-arrow-left"></i>
                            <span>
                                Regresar
                            </span>
                        </Button>
                        {
                            (idTemplate === null || idTemplate === undefined) && <Button
                                type="button"
                                className="survey-sampling-button-restore"
                                onClick={() => handleRestoreDemo(true)}
                                outline
                            >
                                <i className="fa fa-refresh"></i>

                                <span>
                                    Restaurar Encuesta
                                </span>
                            </Button>
                        }


                        <Button
                            type="button"
                            className="survey-sampling-button-save"
                            onClick={() => handleSave()}
                        >
                            <i className="fa fa-floppy-o"></i>
                            <span>
                                Guardar Cambios
                            </span>
                        </Button>


                        <Button
                            type="button"
                            className="survey-sampling-button-save"
                            onClick={handleOpenOrderDialog}
                        >
                            <i className="fa fa-sort"></i>

                            <span>
                                Modificar Orden
                            </span>
                        </Button>



                    </Col>

                </Row>

            </div>
            {
                // ! SURVEY HEADER
            }
            <div className="survey-sampling-general-information">

                <Row className="survey-sampling-general-row">

                    <Col
                        xs="12"
                        lg="5"
                        className="survey-sampling-general-column"
                    >
                        <div className="survey-sampling-form-group">

                            <label
                                htmlFor="survey-sampling-title"
                                className="survey-sampling-form-label"
                            >
                                Título del consentimiento
                            </label>

                            <div className="survey-sampling-input-container">

                                <i className="fa fa-file-text-o survey-sampling-input-icon"></i>

                                <input
                                    id="survey-sampling-title"
                                    type="text"
                                    className="survey-sampling-form-control survey-sampling-form-control-icon"
                                    placeholder="Ej. Consentimiento informado para cirugía"
                                    value={formSurvey?.title}
                                    onChange={(e) =>
                                        handleChangeSurvey(
                                            "title",
                                            e?.target?.value
                                        )
                                    }
                                />

                            </div>

                        </div>
                    </Col>

                    <Col
                        xs="12"
                        lg="5"
                        className="survey-sampling-general-column"
                    >
                        <div className="survey-sampling-form-group">

                            <label
                                htmlFor="survey-sampling-department"
                                className="survey-sampling-form-label"
                            >
                                Departamento / Especialidad
                            </label>

                            <div className="survey-sampling-select-container">
                                <Select
                                    inputId="survey-sampling-department"
                                    className="survey-sampling-react-select"
                                    classNamePrefix="survey-sampling-react-select"

                                    placeholder="Seleccione una o varias secciones..."

                                    options={departments}

                                    isMulti
                                    isSearchable
                                    isClearable
                                    closeMenuOnSelect={false}

                                    noOptionsMessage={() => "No se encontraron secciones"}

                                    value={
                                        departments.filter((item) =>
                                            (formSurvey?.department || [])
                                                .map(String)
                                                .includes(String(item?.value))
                                        )
                                    }

                                    onChange={(selectedOptions) =>
                                        handleChangeSurvey(
                                            "department",
                                            selectedOptions
                                                ? selectedOptions.map((option) => option.value)
                                                : []
                                        )
                                    }

                                    components={{
                                        Option: SurveySamplingOption
                                    }}
                                />

                                <i className="fa fa-angle-down survey-sampling-select-icon"></i>
                            </div>

                        </div>
                    </Col>

                    <Col
                        xs="12"
                        lg="2"
                        className="survey-sampling-general-column"
                    >
                        <div className="survey-sampling-form-group">

                            <label
                                htmlFor="survey-sampling-version"
                                className="survey-sampling-form-label"
                            >
                                Versión del documento
                            </label>

                            <input
                                id="survey-sampling-version"
                                type="text"
                                className="survey-sampling-form-control"
                                value={formSurvey?.version}
                                onChange={(e) =>
                                    handleChangeSurvey(
                                        "version",
                                        e?.target?.value
                                    )
                                }
                            />

                        </div>
                    </Col>

                </Row>

            </div>

            {
                // ! CREATION OF A TEMPLATE ALONGSIDE A VISUALIZER
            }

            <div className="survey-sampling-designer">

                <Row className="survey-sampling-designer-row">
                    <Col
                        xs="12"
                        lg="7"
                        xl="7"
                        className="survey-sampling-builder-column"
                    >
                        <div className="survey-sampling-builder">

                            <div className="survey-sampling-builder-header">

                                <div className="survey-sampling-builder-heading">

                                    <h2 className="survey-sampling-builder-title">
                                        Estructura del Consentimiento
                                    </h2>

                                </div>

                                <div className="survey-sampling-question-counter">

                                    <strong>
                                        {questions.length}
                                    </strong>

                                    <span>
                                        {questions.length === 1
                                            ? "pregunta"
                                            : "preguntas"}
                                    </span>

                                </div>
                            </div>



                            {questions.length === 0 && (
                                <div className="survey-sampling-empty-builder">

                                    <div className="survey-sampling-empty-builder-icon">
                                        <i className="icofont icofont-picture"></i>
                                    </div>

                                    <h3 className="survey-sampling-empty-builder-title">
                                        Comience su Consentimiento
                                    </h3>

                                    <p className="survey-sampling-empty-builder-description">
                                        Aún no tiene preguntas. Seleccione un tipo de pregunta
                                        para comenzar:
                                    </p>

                                </div>
                            )}


                            <div className="survey-sampling-questions-list">
                                {questions.map((question, index) => (
                                    <QuestionCard
                                        key={question?.id}
                                        question={question}
                                        index={index}
                                        onChange={handleUpdateQuestion}
                                        onDelete={handleDeleteQuestion}
                                    />
                                ))}
                            </div>

                            {
                                // * CONFIGURATION BUTTONS
                            }

                            <div className="survey-sampling-question-type-actions pt-4">

                                <button
                                    type="button"
                                    className="survey-sampling-question-button survey-sampling-question-button-open"
                                    onClick={() => handleAddQuestion("open")}
                                >
                                    <i className="fa fa-plus"></i>
                                    <span>Abierta</span>
                                </button>

                                <button
                                    type="button"
                                    className="survey-sampling-question-button  survey-sampling-question-button-time"
                                    onClick={() => handleAddQuestion("time")}
                                >
                                    <i className="fa fa-clock-o"></i>
                                    <span>Tiempo / Ayuno</span>
                                </button>

                                <button
                                    type="button"
                                    className="survey-sampling-question-button survey-sampling-question-button-closed"
                                    onClick={() => handleAddQuestion("complex")}
                                >
                                    <i className="fa fa-check-circle"></i>
                                    <span>Compleja</span>
                                </button>

                                <button
                                    type="button"
                                    className="survey-sampling-question-button survey-sampling-question-button-multiple"
                                    onClick={() => handleAddQuestion("multiple")}
                                >
                                    <i className="fa fa-list-ul"></i>
                                    <span>Múltiple</span>
                                </button>

                            </div>
                        </div>
                    </Col>

                    {
                        // ! PREVIEW TEMPLATE
                    }
                    <Col
                        xs="12"
                        lg="5"
                        xl="5"
                        className="survey-sampling-preview-column"
                    >
                        <div className="survey-sampling-preview">

                            <div className="survey-sampling-preview-header">

                                <div className="survey-sampling-preview-heading">

                                    <i className="fa fa-eye"></i>
                                    <span>
                                        Simulador del Paciente
                                    </span>

                                </div>

                                <span className="survey-sampling-preview-status">
                                    Previsualización Activa
                                </span>

                            </div>

                            <div className="survey-sampling-preview-document">

                                <div className="survey-sampling-preview-document-header">

                                    <div className="survey-sampling-preview-reference">

                                        <div className="survey-sampling-preview-reference-icon">
                                            <i className="fa fa-file-text-o"></i>
                                        </div>

                                        <div>
                                            <span>
                                                {formSurvey?.title || "Consentimiento Informado"}
                                            </span>

                                            {/* <strong>
                                                01
                                            </strong> */}
                                        </div>

                                    </div>

                                    <div className="survey-sampling-preview-version">
                                        {/* <span>
                                            Versión
                                        </span> */}

                                        <strong>
                                            Versión: {formSurvey?.version || "1.0.0"}
                                        </strong>
                                    </div>

                                </div>

                                {/* <h3 className="survey-sampling-preview-title">
                                    {formSurvey?.title || "Consentimiento Informado"}
                                </h3> */}

                                <div className="survey-sampling-preview-metadata">

                                    <span className="survey-sampling-preview-chip">
                                        Depto:
                                        <strong>
                                            {
                                                departments.find(
                                                    (item) =>
                                                        String(item?.value) ===
                                                        String(formSurvey?.department)
                                                )?.label || "Sin seleccionar"
                                            }
                                        </strong>
                                    </span>

                                    <span className="survey-sampling-preview-chip">
                                        Preguntas:
                                        <strong>
                                            {questions.length}
                                        </strong>
                                    </span>

                                </div>

                                <div className="survey-sampling-preview-instructions">

                                    <div className="survey-sampling-preview-instructions-icon">
                                        <i className="fa fa-question-circle-o"></i>
                                    </div>

                                    <p>
                                        <strong>
                                            Instrucciones:
                                        </strong>

                                        Ingrese la información solicitada de manera
                                        precisa. Los campos marcados como requeridos
                                        deberán responderse antes de continuar.
                                    </p>

                                </div>

                                {questions.length === 0 ? (

                                    <div className="survey-sampling-preview-empty">

                                        <i className="fa fa-file-text-o"></i>

                                        <span>
                                            Las preguntas agregadas aparecerán aquí.
                                        </span>

                                    </div>

                                ) : (

                                    <div className="survey-sampling-preview-questions">

                                        {questions.map((question, index) => (

                                            <React.Fragment key={question?.id}>

                                                {question?.type === "open" && (

                                                    <div className="survey-sampling-preview-question">

                                                        <div className="survey-sampling-preview-question-header">

                                                            <span className="survey-sampling-preview-question-number">
                                                                {index + 1}.
                                                            </span>

                                                            <span className="survey-sampling-preview-question-text">

                                                                {question?.question.trim() !== ""
                                                                    ? question?.question
                                                                    : "Escriba el texto de la pregunta"}

                                                                {question?.required && (
                                                                    <span className="survey-sampling-preview-required">
                                                                        *
                                                                    </span>
                                                                )}

                                                            </span>

                                                        </div>

                                                        <textarea
                                                            className="survey-sampling-preview-open-answer"
                                                            placeholder={
                                                                question?.placeholder.trim() !== ""
                                                                    ? question?.placeholder
                                                                    : "Escriba su respuesta..."
                                                            }
                                                            rows={3}
                                                            disabled
                                                        />

                                                    </div>

                                                )}

                                                {question?.type === "time" && (

                                                    <div className="survey-sampling-preview-question">

                                                        <div className="survey-sampling-preview-question-header">

                                                            <span className="survey-sampling-preview-question-number">
                                                                {index + 1}.
                                                            </span>

                                                            <span className="survey-sampling-preview-question-text">

                                                                {question?.question.trim() !== ""
                                                                    ? question?.question
                                                                    : "Pregunta de tiempo"}

                                                                {question?.required && (
                                                                    <span className="survey-sampling-preview-required">
                                                                        *
                                                                    </span>
                                                                )}

                                                            </span>

                                                        </div>



                                                        <Col sm="12">
                                                            <Row>
                                                                <Col sm="5">
                                                                    <div className="survey-sampling-preview-time">
                                                                        <input
                                                                            type="time"
                                                                            value={timeValue}
                                                                            onChange={handleTimeChange}
                                                                            className="survey-sampling-preview-time-input"
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <div className="survey-sampling-preview-fasting-actions">

                                                                        <button
                                                                            type="button"
                                                                            className="survey-sampling-preview-fasting-button"
                                                                            disabled={
                                                                                !timeValue ||
                                                                                timeNotApplicable
                                                                            }
                                                                        >
                                                                            <i className="fa fa-clock-o"></i>

                                                                            <span>
                                                                                {fastingTime
                                                                                    ? `Ayuno de ${fastingTime}`
                                                                                    : "Seleccione una hora"}
                                                                            </span>
                                                                        </button>



                                                                    </div>
                                                                </Col>

                                                            </Row>
                                                        </Col>





                                                    </div>

                                                )}

                                                {
                                                    // ? COMPLEJA
                                                }
                                                {question.type === "complex" && (
                                                    <div className="survey-sampling-preview-question" >
                                                        <div className="survey-sampling-preview-question-header">

                                                            <span className="survey-sampling-preview-question-number">
                                                                {index + 1}.
                                                            </span>

                                                            <span className="survey-sampling-preview-question-text">

                                                                {question?.question.trim() !== ""
                                                                    ? question?.question
                                                                    : ""}

                                                                {question?.required && (
                                                                    <span className="survey-sampling-preview-required">
                                                                        *
                                                                    </span>
                                                                )}

                                                            </span>

                                                        </div>
                                                        <div className="survey-sampling-preview-closed mt-0 pt-0">

                                                            <div className="survey-sampling-preview-closed-options">

                                                                {(question.options || []).map((option) => {

                                                                    const isSelected =
                                                                        selectedClosedOptions[question.id] === option.value;

                                                                    return (
                                                                        <button
                                                                            key={option.id}
                                                                            type="button"
                                                                            className={
                                                                                isSelected
                                                                                    ? "survey-sampling-preview-closed-button survey-sampling-preview-closed-button-active"
                                                                                    : "survey-sampling-preview-closed-button"
                                                                            }
                                                                            onClick={() =>
                                                                                handleSelectClosedOption(
                                                                                    question.id,
                                                                                    option.value
                                                                                )
                                                                            }
                                                                        >
                                                                            {option.label || "Sin nombre"}
                                                                        </button>
                                                                    );
                                                                })}

                                                            </div>

                                                            {(question.options || []).map((option) => {

                                                                const isSelected =
                                                                    selectedClosedOptions[question.id] === option.value;

                                                                const shouldShowSubQuestion =
                                                                    isSelected &&
                                                                    option.hasSubQuestion === true &&
                                                                    option.subQuestion;

                                                                if (!shouldShowSubQuestion) {
                                                                    return null;
                                                                }

                                                                return (
                                                                    <div
                                                                        key={`subquestion-${option.id}`}
                                                                        className="survey-sampling-preview-subquestion"
                                                                    >

                                                                        {option.subQuestion.type === "open" && (
                                                                            <>
                                                                                <label className="survey-sampling-preview-subquestion-label">
                                                                                    {option.subQuestion.question ||
                                                                                        "Escriba la subpregunta"}
                                                                                </label>

                                                                                <textarea
                                                                                    className="survey-sampling-preview-subquestion-textarea"
                                                                                    value={
                                                                                        openSubQuestionAnswers[option.id] || ""
                                                                                    }
                                                                                    placeholder={
                                                                                        option.subQuestion.placeholder ||
                                                                                        "Escriba su respuesta"
                                                                                    }
                                                                                    onChange={(event) =>
                                                                                        setOpenSubQuestionAnswers((previous) => ({
                                                                                            ...previous,
                                                                                            [option.id]: event.target.value
                                                                                        }))
                                                                                    }
                                                                                />
                                                                            </>
                                                                        )}


                                                                        {option.subQuestion.type === "time" && (
                                                                            <>
                                                                                <label className="survey-sampling-preview-subquestion-label">
                                                                                    {option.subQuestion.question ||
                                                                                        "Seleccione una hora"}
                                                                                </label>

                                                                                <Col sm="6" >
                                                                                    <div className="survey-sampling-preview-time">
                                                                                        <input
                                                                                            type="time"
                                                                                            className="survey-sampling-preview-time-input"
                                                                                            step={
                                                                                                option.subQuestion.timeFormat ===
                                                                                                    "hours_minutes_seconds"
                                                                                                    ? "1"
                                                                                                    : "60"
                                                                                            }
                                                                                            value={
                                                                                                timeSubQuestionAnswers[option.id] || ""
                                                                                            }
                                                                                            onChange={(event) =>
                                                                                                setTimeSubQuestionAnswers((previous) => ({
                                                                                                    ...previous,
                                                                                                    [option.id]: event.target.value
                                                                                                }))
                                                                                            }
                                                                                        />

                                                                                    </div>
                                                                                </Col>




                                                                            </>
                                                                        )}

                                                                        {option.subQuestion.type === "multiple" && (
                                                                            <>
                                                                                <label className="survey-sampling-preview-subquestion-label">
                                                                                    {option.subQuestion.question ||
                                                                                        "Seleccione una opción"}
                                                                                </label>

                                                                                <div className="survey-sampling-preview-submultiple-options">

                                                                                    {(option.subQuestion.options || []).map(
                                                                                        (subOption, subOptionIndex) => {

                                                                                            const isMultiple =
                                                                                                option.subQuestion.selectionMode ===
                                                                                                "multiple";

                                                                                            const isSelected = isMultiple
                                                                                                ? (
                                                                                                    multipleSubAnswers[
                                                                                                    option.id
                                                                                                    ] || []
                                                                                                ).includes(subOption.value)
                                                                                                : singleMultipleSubAnswers[
                                                                                                option.id
                                                                                                ] === subOption.value;

                                                                                            return (
                                                                                                <label
                                                                                                    key={subOption.id}
                                                                                                    className={
                                                                                                        isSelected
                                                                                                            ? "survey-sampling-preview-submultiple-option survey-sampling-preview-submultiple-option-active"
                                                                                                            : "survey-sampling-preview-submultiple-option"
                                                                                                    }
                                                                                                >

                                                                                                    <input
                                                                                                        type={
                                                                                                            isMultiple
                                                                                                                ? "checkbox"
                                                                                                                : "radio"
                                                                                                        }
                                                                                                        name={
                                                                                                            isMultiple
                                                                                                                ? undefined
                                                                                                                : `subquestion-${option.id}`
                                                                                                        }
                                                                                                        checked={isSelected}
                                                                                                        onChange={() => {
                                                                                                            if (isMultiple) {
                                                                                                                handleMultipleSubAnswer(
                                                                                                                    option.id,
                                                                                                                    subOption.value
                                                                                                                );
                                                                                                            } else {
                                                                                                                setSingleMultipleSubAnswers(
                                                                                                                    (previous) => ({
                                                                                                                        ...previous,
                                                                                                                        [option.id]:
                                                                                                                            subOption.value
                                                                                                                    })
                                                                                                                );
                                                                                                            }
                                                                                                        }}
                                                                                                    />



                                                                                                    <span className="survey-sampling-preview-submultiple-text">
                                                                                                        {subOption.label ||
                                                                                                            `Opción ${String.fromCharCode(
                                                                                                                65 + subOptionIndex
                                                                                                            )}`}
                                                                                                    </span>

                                                                                                </label>
                                                                                            );
                                                                                        }
                                                                                    )}

                                                                                </div>
                                                                            </>
                                                                        )}

                                                                    </div>
                                                                );
                                                            })}

                                                        </div>


                                                    </div>



                                                )}


                                                {
                                                    // ? TYPPE 4
                                                }
                                                {question?.type === "multiple" && (

                                                    <div className="survey-sampling-preview-question">

                                                        <div className="survey-sampling-preview-question-header">

                                                            <span className="survey-sampling-preview-question-number">
                                                                {index + 1}.
                                                            </span>

                                                            <span className="survey-sampling-preview-question-text">

                                                                {question?.question?.trim() !== ""
                                                                    ? question.question
                                                                    : "Escriba el texto de la pregunta"}

                                                                {question?.required && (
                                                                    <span className="survey-sampling-preview-required">
                                                                        *
                                                                    </span>
                                                                )}

                                                            </span>

                                                        </div>

                                                        <div
                                                            className={
                                                                question?.displayType === "button"
                                                                    ? "survey-sampling-preview-multiple-options survey-sampling-preview-multiple-options-buttons"
                                                                    : "survey-sampling-preview-multiple-options"
                                                            }
                                                        >

                                                            {Array.isArray(question?.options) &&
                                                                question.options.length > 0 ? (

                                                                question.options.map((option, optionIndex) => {

                                                                    const optionText =
                                                                        typeof option === "string"
                                                                            ? option
                                                                            : option?.label || option?.text || "";

                                                                    const allowMultiple =
                                                                        question?.allowMultiple !== false;

                                                                    const isSelected = allowMultiple
                                                                        ? (
                                                                            multipleAnswers[question.id] || []
                                                                        ).includes(optionIndex)
                                                                        : singleAnswers[question?.id] === optionIndex;

                                                                    const inputType = allowMultiple
                                                                        ? "checkbox"
                                                                        : "checkbox";

                                                                    return (

                                                                        <label
                                                                            key={option?.id || optionIndex}
                                                                            className={
                                                                                isSelected
                                                                                    ? "survey-sampling-preview-multiple-option survey-sampling-preview-multiple-option-selected"
                                                                                    : "survey-sampling-preview-multiple-option"
                                                                            }
                                                                        >

                                                                            <input
                                                                                type={inputType}
                                                                                name={
                                                                                    allowMultiple
                                                                                        ? undefined
                                                                                        : `question-${question?.id}`
                                                                                }
                                                                                checked={isSelected}
                                                                                onChange={() => {

                                                                                    if (allowMultiple) {

                                                                                        handleMultipleAnswerChange(
                                                                                            question?.id,
                                                                                            optionIndex
                                                                                        );

                                                                                    } else {

                                                                                        handleSingleAnswerChange(
                                                                                            question?.id,
                                                                                            optionIndex
                                                                                        );

                                                                                    }

                                                                                }}
                                                                            />

                                                                            <span>
                                                                                {optionText.trim() !== ""
                                                                                    ? optionText
                                                                                    : `Opción ${optionIndex + 1}`}
                                                                            </span>

                                                                        </label>

                                                                    );

                                                                })

                                                            ) : (

                                                                <div className="survey-sampling-preview-multiple-empty">
                                                                    Aún no se han agregado opciones
                                                                </div>

                                                            )}

                                                        </div>

                                                    </div>

                                                )}

                                            </React.Fragment>

                                        ))}
                                        <div className="survey-signature-section">

                                            <div className="survey-signature-header">

                                                <div className="survey-signature-icon">
                                                    <i className="fa fa-pencil-square-o"></i>
                                                </div>

                                                <div className="survey-signature-title">
                                                    <strong>Firmas del consentimiento</strong>
                                                    <span>
                                                        Seleccione las firmas que serán obligatorias al finalizar el consentimiento.
                                                    </span>
                                                </div>

                                            </div>

                                            <div className="survey-signature-options">

                                                <label className="survey-signature-option">
                                                    <input
                                                        type="checkbox"
                                                        checked={formSurvey.patient_signature}
                                                        onChange={() => handleToggleSignature("patient_signature")}
                                                    />

                                                    <span>Firma del paciente</span>
                                                </label>

                                                <label className="survey-signature-option">
                                                    <input
                                                        type="checkbox"
                                                        checked={formSurvey.phlebotomist_signature}
                                                        onChange={() => handleToggleSignature("phlebotomist_signature")}
                                                    />

                                                    <span>Firma del flebotomista</span>
                                                </label>

                                            </div>

                                        </div>





                                    </div>

                                )}
                            </div>

                        </div>
                    </Col>

                </Row>

            </div>
            {
                // * SPACE
            }
            <br /> <br /> <br /> <br /> <br /> <br />

            {
                // * CONFIGURATION ALERT
            }
            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />

            {
                // * CONFIGURATION ALERT
            }

            <CustomAlertDialogGlobal
                visible={customAlert.visible}
                mode={customAlert.mode}
                type={customAlert.type}
                title={customAlert.title}
                message={customAlert.message}
                buttonText={customAlert.buttonText}
                cancelText={customAlert.cancelText}
                onAccept={customAlert.onAccept}
                onCancel={customAlert.onCancel}
            />

            <ToastAletGlobal
                visible={showToast}
                type={toastType}
                title={toastTitle}
                message={toastMessage}
                onClose={closeToastAlert}
            />

            {
                showAlert && (
                    <CustomAlertModal
                        visible={showAlert}
                        title="¿Limpiar consentimiento?"
                        message={`Los datos capturados actualmente se perderán. ¿Desea continuar?`}
                        buttonText="Sí, limpiar"
                        cancelText="Cancelar"
                        onAccept={confirmRestore}
                        onCancel={cancelRestore}
                    />
                )
            }


            {
                // * ORDER
            }
            <Dialog
                visible={showOrderDialog}
                onHide={() => setShowOrderDialog(false)}
                draggable={false}
                resizable={false}
                modal
                closable={false}
                header={
                    <div className="Global-dialog-header">
                        <div className="Global-dialog-header__content">
                            <div className="Global-dialog-icon">
                                <i className="fa fa-sort"></i>
                            </div>

                            <div>
                                <div className="Global-dialog-title">
                                    Ordenar preguntas

                                </div>
                            </div>
                        </div>
                    </div>
                }
                maskClassName="custom-total-mask"
                className="Global-dialog Global-blue Global-medium"
                footer={
                    <div className="survey-sampling-order-dialog-footer">

                        <Button
                            type="button"
                            onClick={() => setShowOrderDialog(false)}
                            color="danger"
                        >
                            Cancelar
                        </Button>


                        <Button
                            type="button"
                            onClick={handleSaveQuestionOrder}
                            color="secondary"
                        >

                            Ordenar
                        </Button>

                    </div>
                }
            > <br />

                <div className="survey-sampling-order-help ">

                    <i className="fa fa-info-circle"></i>

                    <span>
                        Mantén presionada una tarjeta y
                        arrástrala hasta la posición deseada.
                    </span>

                </div>


                <div className="survey-sampling-order-list">

                    {orderQuestions.map(
                        (question, index) => (

                            <div
                                key={question?.id}

                                draggable

                                onDragStart={(e) =>
                                    handleDragStartQuestion(
                                        e,
                                        index
                                    )
                                }

                                onDrag={(e) =>
                                    handleDragQuestion(e)
                                }

                                onDragEnter={() =>
                                    handleDragEnterQuestion(
                                        index
                                    )
                                }

                                onDragEnd={
                                    handleDragEndQuestion
                                }

                                onDragOver={(e) =>
                                    e.preventDefault()
                                }

                                className={`
                    survey-sampling-order-card

                    ${draggedQuestionIndex === index
                                        ? "survey-sampling-order-card-source"
                                        : ""
                                    }

                    ${dragOverQuestionIndex === index
                                        ? "survey-sampling-order-card-over"
                                        : ""
                                    }
                `}
                            >

                                <div className="survey-sampling-order-number">
                                    {index + 1}
                                </div>


                                <div className="survey-sampling-order-information">

                                    <div className="survey-sampling-order-question">

                                        {question?.question ||
                                            "Pregunta sin título"}

                                    </div>


                                    <div className="survey-sampling-order-meta">

                                        <span>
                                            {getQuestionTypeLabel(
                                                question?.type
                                            )}
                                        </span>

                                        {question?.required && (

                                            <span className="survey-sampling-order-required">
                                                Obligatoria
                                            </span>

                                        )}

                                    </div>

                                </div>


                                <div className="survey-sampling-order-handle">

                                    <i className="fa fa-bars"></i>

                                </div>

                            </div>
                        )
                    )}



                    {draggedQuestionIndex !== null && (
                        <div
                            className="survey-sampling-order-drag-preview"

                            // style={{
                            //     width: `${dragWidth}px`,
                            //     left: `${dragPosition.x}px`,
                            //     top: `${dragPosition.y}px`
                            // }}
                            style={{
                                width: `${dragWidth}px`,
                                left: `${dragPosition.x - dragOffset.x}px`,
                                top: `${dragPosition.y - dragOffset.y}px`
                            }}
                        >
                            <div className="survey-sampling-order-number">

                                {draggedQuestionIndex + 1}

                            </div>


                            <div className="survey-sampling-order-information">

                                <div className="survey-sampling-order-question">

                                    {orderQuestions[
                                        draggedQuestionIndex
                                    ]?.question ||
                                        "Pregunta sin título"}

                                </div>


                                <div className="survey-sampling-order-meta">

                                    <span>

                                        {getQuestionTypeLabel(
                                            orderQuestions[
                                                draggedQuestionIndex
                                            ]?.type
                                        )}

                                    </span>


                                    {orderQuestions[
                                        draggedQuestionIndex
                                    ]?.required && (

                                            <span className="survey-sampling-order-required">
                                                Obligatoria
                                            </span>

                                        )}

                                </div>

                            </div>


                            <div className="survey-sampling-order-handle">

                                <i className="fa fa-bars"></i>

                            </div>

                        </div>
                    )}

                </div>

            </Dialog>


        </div >
    )
}
